export default "__VITE_ASSET__DlRZ7m0S__"